/**
 * 화면 언어 (2026-10-11 글로벌 준비: 영어권). 문구는 쓰는 자리에서 L('한국어', 'English') 로 둘 다 적는다.
 * 언어: 설정에서 고른 값(localStorage 'lang') → 없으면 휴대폰·브라우저 언어(한국어가 아니면 영어).
 * 바꾸면 화면을 새로 연다(setLang).
 */
export type Lang = 'ko' | 'en';

/** 해외 출시 때 true: 한국어가 아닌 휴대폰은 처음부터 영어 */
const GLOBAL_AUTO = false;
/** 설정 화면에 언어 고르기를 보여 줄지 (해외 출시 전에는 영어로 들어온 사람만) */
export const showLangSetting = () => GLOBAL_AUTO || current === 'en';

const detect = (): Lang => {
  try {
    const saved = localStorage.getItem('lang');
    if (saved === 'ko' || saved === 'en') return saved;
  } catch (e) {}
  // 주소에 ?lang=en 이면 그 언어로 (시험·해외 링크용)
  try {
    const q = new URLSearchParams(window.location.search).get('lang');
    if (q === 'en' || q === 'ko') {
      localStorage.setItem('lang', q);
      return q;
    }
  } catch (e) {}
  // 해외 출시 전까지는 휴대폰 언어로 자동 전환하지 않는다 (영어 휴대폰을 쓰는 국내 회원이 갑자기 영어 화면을 보지 않게)
  if (!GLOBAL_AUTO) return 'ko';
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || 'ko']) as string[];
  return /^ko/i.test(langs[0] || 'ko') ? 'ko' : 'en';
};

let current: Lang = detect();
try {
  document.documentElement.lang = current;
} catch (e) {}

export const lang = () => current;
export const isEn = () => current === 'en';

/** L('악보', 'Sheet') — 지금 언어의 문구 */
export const L = (ko: string, en: string) => (current === 'en' ? en : ko);

export const setLang = (l: Lang) => {
  try {
    localStorage.setItem('lang', l);
  } catch (e) {}
  current = l;
  window.location.reload();
};

/** 가사 표기: 한글 / 로마자 / 둘 다. 영어 화면은 처음에 '둘 다' */
export type LyricScript = 'ko' | 'rom' | 'both';
export const lyricScript = (): LyricScript => {
  try {
    const v = localStorage.getItem('lyricScript');
    if (v === 'ko' || v === 'rom' || v === 'both') return v;
  } catch (e) {}
  return current === 'en' ? 'both' : 'ko';
};
export const setLyricScript = (v: LyricScript) => {
  try {
    localStorage.setItem('lyricScript', v);
  } catch (e) {}
  window.dispatchEvent(new Event('cs-lyric-script'));
};
